import { createSlice } from '@reduxjs/toolkit'
import Constants from '../../Constants';

export const ProjectFilterSlice = createSlice({
    name: "project_filters",
    initialState: {
            Campaign: {label : '', value : ''},
            Delivery_Status: {label : '', value : ''},
            Content_Source: {label : '', value : ''},
            Intended_Use: {label : '', value : ''},
            Project_Id: {label : ''},
            Translations_By: {label : '', value : ''},
            Project_Owner: {label : '', value : ''},
            Purchase_Order: {label : '', value : ''},
            Source_Language: {label : '', value : ''},
            Tags: {label : '', value : ''},
            Target_Language: {label : '', value : ''}
    },
    reducers: {
        updateSelectedFilters: (state, action) => {
            state = action.payload;
            return state;
        },
        setDefaultValueForFilter: (state, action) => {
            if(action.payload.type === Constants.CAMPAIGN) {
                state.Campaign = action.payload.payload
            }
            if(action.payload.type === Constants.DELIVERY_STATUS) {
                state.Delivery_Status = action.payload.payload
            }
            if(action.payload.type === Constants.CONTENT_SOURCE) {
                state.Content_Source = action.payload.payload
            }
            if(action.payload.type === Constants.INTENDED_USE) {
                state.Intended_Use = action.payload.payload
            }
            if(action.payload.type === Constants.PROJECT_ID) {
                state.Project_Id = action.payload.payload
            }
            if(action.payload.type === Constants.TRANSLATIONS_BY) {
                state.Translations_By = action.payload.payload
            }
            if(action.payload.type === Constants.PROJECT_OWNER) {
                state.Project_Owner = action.payload.payload
            }
            if(action.payload.type === Constants.PURCHASE_ORDER) {
                state.Purchase_Order = action.payload.payload
            }
            if(action.payload.type === Constants.SOURCE_LANGUAGE) {
                state.Source_Language = action.payload.payload
            }
            if(action.payload.type === Constants.TAGS) {
                state.Tags = action.payload.payload
            }
            if(action.payload.type === Constants.TARGET_LANGUAGE) {
                state.Target_Language = action.payload.payload
            }
            return state;
        }
    },
})
export const { updateSelectedFilters } = ProjectFilterSlice.actions
export const { setDefaultValueForFilter } = ProjectFilterSlice.actions

export default ProjectFilterSlice.reducer